import { render, staticRenderFns } from "./kvkk.vue?vue&type=template&id=cb513274&scoped=true&"
import script from "./kvkk.vue?vue&type=script&lang=js&"
export * from "./kvkk.vue?vue&type=script&lang=js&"
import style0 from "./kvkk.vue?vue&type=style&index=0&id=cb513274&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb513274",
  null
  
)

export default component.exports